import { type BaseParams, NodeData } from './base';
import type { DatasourceMeta } from './factory';
import type { ContextItemData, DatasourceItemData } from './types';

/**
 * Type used to create a datasource context item.
 *
 * All required attributes will be inferred from the datasources uid.
 */
export interface CreateDatasourceContextParams extends BaseParams {
  datasourceUid: string;
}

export class DatasourceNodeData extends NodeData {
  public datasourceUid: string;
  public datasourceType: string;
  public datasourceName: string;
  public img?: string;

  constructor(params: CreateDatasourceContextParams & DatasourceMeta) {
    super({ ...params, id: params.datasourceUid, type: 'datasource' });
    this.datasourceUid = params.datasourceUid;
    this.datasourceType = params.datasourceType;
    this.datasourceName = params.datasourceName;
    this.img = params.img;
    this.text = params.datasourceName;
  }

  formatForLLM(codeElementIds?: string[]): ContextItemData {
    return {
      type: this.type,
      codeElementIds,
      bypassLimits: this.bypassLimits,
      data: {
        name: this.datasourceName,
        uid: this.datasourceUid,
        type: this.datasourceType,
        text: this.text,
      } satisfies DatasourceItemData,
    };
  }
}
